// extracted by mini-css-extract-plugin
export default {"bulk-assign-modal":"g__bulk-assign-modal--RHd2v","modal-content":"g__modal-content--S85ZS","form-field":"g__form-field--oBdty","info-message":"g__info-message--GcUbb"};